import config from 'config';
import sortBy from 'lodash/sortBy';

export const currencyMap = {
  AUD: '$',
  GBP: '£',
  USD: '$',
};

type CurrencyPenny = '¢' | 'p';

export const currencyMapToPenny: Record<Currency, CurrencyPenny> = {
  AUD: '¢',
  GBP: 'p',
  USD: '¢',
};

export const currencyToCountryCodeMap: Record<Currency, Country> = {
  AUD: 'AU',
  GBP: 'GB',
  USD: 'US',
};

interface CurrencyName {
  code: Currency;
  name: string;
}

const countryToCurrencyMap: Record<Country, CurrencyName> = {
  AU: { code: 'AUD', name: '$ - Australian Dollar' },
  GB: { code: 'GBP', name: '£ - Great British Pound' },
  US: { code: 'USD', name: '$ - United States Dollar' },
};

export const supportedCurrencies = sortBy(
  config.ENABLED_COUNTRIES.map(countryCode => ({
    country: countryCode,
    currency: countryToCurrencyMap[countryCode],
  })),
  ['country']
);

export default currencyMap;



// WEBPACK FOOTER //
// ./src/helpers/currencyMap.ts